import { JsonQuery, TJsonQuery } from '../../../packages/JsonQuery';
import { TModifier } from 'shared/types/filters';

export function modifyJsonQuery(jsonQuery: TJsonQuery, modifiers: [TModifier, ...TModifier[]]): TJsonQuery {
  const jq = new JsonQuery(jsonQuery);

  modifiers.forEach(modifier => {
    // oxlint-disable-next-line typescript/no-explicit-any
    (jq[modifier.action] as any)(...modifier.arguments);
  });

  return jq.toJSON();
}
